import './VideoCard.css';

function VideoCard(props) {
    const {
        videoIndex, thumbnail, description, title, handleVideoClick,
    } = props;

    return (
        <div
            role="button"
            tabIndex={videoIndex}
            className="video-card__container"
            data-video-index={videoIndex}
            onClick={(e) => handleVideoClick(e)}
            onKeyDown={(e) => handleVideoClick(e)}>
            <div className="video-card__thumbnail">
                <img alt={`Thumbnail for ${title}`} src={thumbnail} />
            </div>
            <div className="video-card__description">
                <div className="video-card__title">
                    <h3>{title}</h3>
                </div>
                <div className="video-card__text">{description}</div>
            </div>
        </div>
    );
}

export default VideoCard;
